import { render, staticRenderFns } from "./ReferralSelector.vue?vue&type=template&id=e0c63c2a"
import script from "./ReferralSelector.vue?vue&type=script&lang=js"
export * from "./ReferralSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports